import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';

export type SelectOption = {
  value: number|string
  label: string
}

@Component({
    selector: 'app-select',
    templateUrl: './select.component.html',
    styleUrl: './select.component.scss',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SelectComponent {
  @Input() emptyLabel = 'Bitte wählen'
  @Input() options: SelectOption[] = []
  selected?: SelectOption = undefined
  @Output() change = new EventEmitter()

  onSelect(e: Event) {
    const select = e.target as HTMLSelectElement

    this.select(select.value)

    if (this.selected) {
      this.change.emit(this.selected.value)
    }
  }

  select(value: number|string) {
    this.selected = this.options.find(option => option.value == value)
  }
}
